import { isAndroid, isIos } from 'util/device';

export default function trackJukeDownloadAppButton(buttonName, eventName, eventAction) {
  let os = '';
  if (isAndroid()) {
    os = 'Android';
  } else if (isIos()) {
    os = 'IOS';
  } else {
    os = 'No ios or android device';
  }

  window.Taq.push([
    'track',
    'link',
    {
      event_name: eventName || 'cta_juke-download-app',
      event_category: 'cta',
      event_action: eventAction || `juke-download-app - ${os}`,
      event_label: buttonName || null,
    },
  ]);
}
